<!--  -->
<template>
  <div class="main grace-flex-center" :style="{ 'padding-top': top }">
    <div class="leftPart">
      <div class="basic_model">
        <div class="basic_1 basic_box">
          <div class="title">基本信息</div>
          <div class="logout" @click="logout">退出</div>
          <div class="basic_line active grace-flex-0-center">
            <div class="icon1 icon_name"></div>
            <div class="label">姓名：</div>
            <div class="info">{{ user_name }}</div>
          </div>
          <div class="basic_line active grace-flex-0-center">
            <div class="icon1 icon_time"></div>
            <div class="label">剩余时间：</div>
            <div class="info">{{ rest_time }}</div>
          </div>
        </div>
        <div class="basic_2 basic_box">
          <div class="title top30">当前进度</div>
          <div
            v-if="tixing.includes(1)"
            class="basic_line grace-flex-0-center"
            :class="progress >= 0 ? 'active' : ''"
          >
            <div class="icon2"></div>
            <div class="label">单选题</div>
          </div>
          <div
            v-if="tixing.includes(2)"
            class="basic_line grace-flex-0-center"
            :class="progress >= 1 ? 'active' : ''"
          >
            <div class="icon2"></div>
            <div class="label">多选题</div>
          </div>
          <div
            v-if="tixing.includes(3)"
            class="basic_line grace-flex-0-center"
            :class="progress >= 2 ? 'active' : ''"
          >
            <div class="icon2"></div>
            <div class="label">判断题</div>
          </div>
          <div
            v-if="tixing.includes(4)"
            class="basic_line grace-flex-0-center"
            :class="progress >= 3 ? 'active' : ''"
          >
            <div class="icon2"></div>
            <div class="label">VR题</div>
          </div>
          <div
            v-for="(item, idx) in ganList"
            :key="idx"
            class="gan"
            :class="(progress >= item ? 'active' : '') + (' gan' + (idx + 1))"
          ></div>
          <!-- <div class="gan" v-if="tixing.includes(2)" :class="(progress >= 1 ? 'active' : '')+(' gan'+(tixing.indexOf(2)))"></div>
          <div class="gan" v-if="tixing.includes(3)" :class="(progress >= 2 ? 'active' : '')+(' gan'+(tixing.indexOf(3)))"></div>
          <div class="gan" v-if="tixing.includes(4)" :class="(progress >= 3 ? 'active' : '')+(' gan'+(tixing.indexOf(4)))"></div> -->
        </div>
      </div>
      <div class="topic_model" v-if="isPC">
        <div class="title">答题卡</div>
        <div
          class="topic_list"
          v-if="canAnwser && dataList[examType] && progress < 3"
        >
          <div
            class="topic_item left"
            :class="topicActive[index] ? 'active' : ''"
            v-for="(item, index) in dataList[examType]"
            :key="index"
          >
            {{ index + 1 }}
          </div>
        </div>
        <el-button
          v-if="canAnwser"
          class="submit"
          type="primary"
          @click="submit(0)"
          >提 交</el-button
        >
      </div>
    </div>
    <div class="midPart">
      <div v-if="progress < 3" class="title_model">
        <div class="title">答题区</div>
        <hr class="hr1" />
        <hr class="hr2" />
        <div
          ref="mainList"
          id="main_list"
          class="title_list"

          v-if="canAnwser && dataList[examType]"
        >
          <div
            class="title_item"
            v-for="(item, index) in dataList[examType]"
            :key="index"
          >
            <div class="title_line">
              <div class="serial left">{{ index + 1 }}</div>
              <div class="title_inner left">
                {{ item.timu.title + examTitle }}
              </div>
            </div>
            <div class="options_list grace-space-between">
              <div
                v-if="item.timu.A"
                class="option_item"
                :class="
                  aswerActive[index] && aswerActive[index].includes('A')
                    ? 'active'
                    : ''
                "
                @click="choose(index, 'A')"
              >
                A.{{ item.timu.A }}
              </div>
              <div
                v-if="item.timu.B"
                class="option_item"
                :class="
                  aswerActive[index] && aswerActive[index].includes('B')
                    ? 'active'
                    : ''
                "
                @click="choose(index, 'B')"
              >
                B.{{ item.timu.B }}
              </div>
              <div
                v-if="item.timu.C"
                class="option_item"
                :class="
                  aswerActive[index] && aswerActive[index].includes('C')
                    ? 'active'
                    : ''
                "
                @click="choose(index, 'C')"
              >
                C.{{ item.timu.C }}
              </div>
              <div
                v-if="item.timu.D"
                class="option_item"
                :class="
                  aswerActive[index] && aswerActive[index].includes('D')
                    ? 'active'
                    : ''
                "
                @click="choose(index, 'D')"
              >
                D.{{ item.timu.D }}
              </div>
            </div>
          </div>
        </div>
      </div>

<!--      {{canAnwser}}-->
<!--      {{tixing.includes(4)}}-->
<!--      {{progress}}-->
<!--      {{vrTime}}-->
      <iframe
        v-if="canAnwser && tixing.includes(4) && progress == 3  && vrTime<=0""
        class="vr_model"
        id="vr_iframe"
        :src="vrSrc"
        frameborder="0"
      ></iframe>
      <div v-if="progress >= lastType" class="end_model">比武已结束</div>
    </div>
    <div
      class="rightPart hiddden"
    >
<!--    <div-->
<!--      class="rightPart"-->
<!--      :class="(isPC ? '' : 'rightPartNoPC') + (isShow ? '' : ' hidden')"-->
<!--    >-->
      <i
        v-if="!isPC"
        class="closeBtn el-icon-circle-close"
        @click="hideRight()"
      ></i>
      <div class="rank_model">
        <div class="title">排行榜</div>
        <hr class="hr1" />
        <hr class="hr2" />
        <div class="rank_list" v-if="canAnwser">
          <div
            class="rank_item grace-space-around-center"
            v-for="(item, index) in phInfo"
            :key="index"
          >
            <div class="rank_num" :class="index < 3 ? 'rank_icon' + index : ''">
              {{ index > 2 ? index + 1 : "" }}
            </div>
            <div class="rank_name">{{ item.user ? item.user.name : "" }}</div>
            <div class="rank_score">
              {{
                progress < 3
                  ? parseInt(item.lilun_score || 0)
                  : parseInt(item.vr_score || 0)
              }}<span class="fen">分</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="topic_model" v-if="!isPC">
      <div class="title">答题卡</div>
      <div
        class="topic_list"
        v-if="canAnwser && dataList[examType] && progress < 3"
      >
        <div
          class="topic_item left"
          :class="topicActive[index] ? 'active' : ''"
          v-for="(item, index) in dataList[examType]"
          :key="index"
        >
          {{ index + 1 }}
        </div>
      </div>
      <el-button v-if="canAnwser" class="submit" type="primary" @click="submit(0)"
        >提 交</el-button
      >
    </div>
<!--    <div-->
<!--      v-if="!isPC"-->
<!--      class="rankBtn pulse animated infinite slow"-->
<!--      @click="showRight()"-->
<!--    >-->
<!--      排行榜-->
<!--    </div>-->
    <div class="dialog" v-if="!canAnwser">
        <p class="tip">{{tip}}</p>
    </div>
    <div v-if="progress >= lastType" class="cover"></div>
<!--    {{canAnwser}}-->
<!--    {{tixing.includes(4)}}-->
<!--    {{progress}}-->
<!--    {{vrTime}}-->
<!--    <div class="vr_wating" v-if="canAnwser && tixing.includes(4) && progress == 3 && vrTime>0">-->
<!--      <p class="tip">-->
<!--&lt;!&ndash;        VR比武时间为{{vr_time_start[0]}}<br>&ndash;&gt;-->
<!--&lt;!&ndash;        倒计时{{rest_time_vr}}开始<br>&ndash;&gt;-->
<!--        理论比武已结束，VR比武还未开始，请稍后再试!</p>-->
<!--    </div>-->
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      initheight: 0,
      top: 0,
      boxHeight: 900,
      tixing: [],
      topicActive: [],
      aswerActive: [],
      progress: 0,
      examList: ["danxuan", "duoxuan", "panduan", "vr"],
      examTime: 0,
      user_id: "",
      user_name: "",
      vr_id: 0,
      phTimer: null,
      canAnwser: false,
      isShow: false,
      is_show: 0, //是否暂时排行榜页面
      vr_time_start:null,
      vrTime:0,
      time_list:{},
      tip:'',
      examTimer:null,
    };
  },

  components: {},

  watch: {
    progress(val) {
      if (val >= this.lastType) {
        // this.jumpRank();
      }
    },
  },
  computed: {
    ...mapGetters({
      // userInfo: "userInfo",
      dataList: "rank/examList",
      phInfo: "rank/phInfo",
      isPC: "rank/isPC"
    }),
    lastType() {
      if (this.tixing.length > 0) {
        return this.tixing[this.tixing.length - 1];
      } else {
        return 4;
      }
    },
    ganList() {
      if (this.tixing.length > 0) {
        return this.tixing.slice(0, this.tixing.length - 1);
      } else {
        return [];
      }
    },
    vrSrc() {
      return `https://zjvrks.zjfazhi.com/pc/examDetail_biwu?id=${this.vr_id}&score_id=${this.score_id}`;
    },
    phType() {
      if (this.progress < 3) {
        return 1;
      } else {
        return 2;
      }
    },
    rest_time() {
      console.log('rest_time..........',this.examTime)

      let h = parseInt(this.examTime / 3600);
      let restTime = this.examTime - 3600 * h;
      let m = parseInt(restTime / 60);
      let s = restTime % 60;
      return `${h < 10 ? "0" + h : h} : ${m < 10 ? "0" + m : m} : ${
        s < 10 ? "0" + s : s
      }`;
    },
    // rest_time_vr() {
    //   console.log('rest_time....2222......',this.vrTime)
    //   if(this.vrTime>0){
    //     let h = parseInt(this.vrTime / 3600);
    //     let restTime = this.vrTime - 3600 * h;
    //     let m = parseInt(restTime / 60);
    //     let s = restTime % 60;
    //     return `${h < 10 ? "0" + h : h} : ${m < 10 ? "0" + m : m} : ${
    //       s < 10 ? "0" + s : s
    //     }`;
    //   }
    //
    // },
    examType() {
      return this.examList[this.progress];
    },
    examTitle() {
      let title = "";
      switch (this.examType) {
        case "danxuan":
          title = "(单选题)";
          break;
        case "duoxuan":
          title = "(多选题)";
          break;
        case "panduan":
          title = "(判断题)";
          break;
      }
      return title;
    },
  },

  async mounted() {
    this.user_id = this.$route.query.id;
    this.user_name = this.$route.query.name;
    this.shijuan_id = this.$route.query.shijuan_id;
    console.log('考题',this.shijuan_id)
    console.log(".........mounted.............")

    if(!this.user_id || !this.user_name){
      this.logout();
      return false;
    }
    window.addEventListener("resize", this.initSize);
    setTimeout(() => {
      this.initSize();
    }, 0);
    this.initExam();
    //监听iframe消息
    window.addEventListener("message", (e) => {
      // console.log(e);
      if (e.data == "vr_exam_over") {
        this.endVr();
        this.jumpRank();
      }
    });
  },
  created() {
    this.$nextTick(() => {
      // 1.禁用右键菜单
      document.oncontextmenu = new Function("event.returnValue=false");
      // 2.禁用鼠标选中
      document.onselectstart = new Function("event.returnValue=false");
      // 3.禁止键盘F12键
      // 3.禁止键盘F12键
      // document.addEventListener("keydown", function (e) {
      //   if (e.key == "F12") {
      //     e.preventDefault(); // 如果按下键F12,阻止事件
      //   }
      // });
    });
  },

  methods: {
    ...mapActions({
      getExamList: "rank/getExamList",
      getphInfo: "rank/getphInfo",
      submitInfo: "rank/submitInfo",
      startExam: "rank/startExam",
      examEnd: "rank/examEnd"
    }),
    initSize() {
      this.initheight = this.getClientHeight();
      this.top =
        (this.initheight > this.boxHeight
          ? (this.initheight - this.boxHeight) / 2
          : 0) + "px";
    },
    logout(){
      // window.location.replace('https://zjvrks.zjfazhi.com/pc/login');
    },
    async initExam() {
      console.log("initExam.............")
      let resp = await this.getExamList({ shijuan_id: this.shijuan_id });
      if (resp && resp.status.state == 1000) {
        let times = resp.content.examtime.split("|");
        console.log("times=====================",times);
        let times_vr = resp.content.vrtime.split("|");
        let times_ll = resp.content.liluntime.split("|");
        this.tixing = resp.content.tixing;
        this.is_show = resp.content.is_show;
        this.time_list.startTime = new Date(times[0].replace(/-/g,'/')).getTime();
        this.time_list.endTime = new Date(times[1].replace(/-/g,'/')).getTime();




        this.time_list.startTimeVR = new Date(times_vr[0].replace(/-/g,'/')).getTime();
        this.time_list.endTimeVR = new Date(times_vr[1].replace(/-/g,'/')).getTime();
        this.time_list.startTimeLL = new Date(times_ll[0].replace(/-/g,'/')).getTime();
        this.time_list.endTimeLL = new Date(times_ll[1].replace(/-/g,'/')).getTime();


        // let nowTime = Date.now();
        // console.log(nowTime , startTime , endTime,nowTime < startTime,nowTime > endTime);
        // // return false;
        // if (nowTime < startTime || nowTime > endTime) {
        //   // console.log('比武未开始!')
        //   // return false;
        //   this.logout();
        //   return this.$message.warning('比武未开始!');
        // } else if (nowTime < endTimeLL && nowTime > startTimeLL) {
        //   console.log("理论比武")
        //   this.examTime = parseInt((endTime - nowTime) / 1000);
          this.vr_id = resp.content.vr ? resp.content.vr.scene_id : "";
          // console.log('vr_time_start',times_vr)
          // this.vr_time_start=times_vr;
          // this.vrTime=parseInt((startTimeVR - nowTime) / 1000);
          // this.canAnwser = true;
        // }
        // else if (nowTime > endTimeLL && nowTime < endTime) {
        //   console.log("理论比武之后")
        //   this.examTime = parseInt((endTime - nowTime) / 1000);
        //   this.vr_id = resp.content.vr ? resp.content.vr.scene_id : "";
        //   console.log('vr_time_start',times_vr)
        //   this.vr_time_start=times_vr;
        //   this.vrTime=parseInt((startTimeVR - nowTime) / 1000);
        //   this.canAnwser = true;
        //   // return this.$message.warning('理论比武已结束，VR比武还未开始，请稍后再试\n!');
        // }else{
        //   // this.$router.replace(
        //   //   `/`
        //   // );
        //   this.logout();
        //   return this.$message.warning('比武已经结束!');
        // }
      }else{
          this.logout();
          return this.$message.warning('试卷信息错误!');
      }
      console.log("1111")
      await this.start();
      this.changeExamType();
      console.log("11112222")
      this.timing();
      this.timer = setInterval(() => {
        this.phInfoFun();
      }, 5000);
    },
    getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        var clientHeight =
          document.body.clientHeight < document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight;
      } else {
        var clientHeight =
          document.body.clientHeight > document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight;
      }
      return clientHeight;
    },
    timing() {
      console.log("timing.............")
      if(this.progress >= this.lastType){
        return false;
      }
      this.examTimer = setInterval(() => {
        let nowTime = Date.now();
        // nowTime=this.time_list.startTimeVR+1;
        console.log(nowTime,this.time_list)
        if(nowTime<this.time_list.startTime){
          console.log("比武还没开始！");
          this.tip='比武未开始!';
          this.examTime=0;
          this.canAnwser=false;
          return false;
          // return this.$message.warning('比武未开始!');
        }else if(nowTime>this.time_list.endTime){
          console.log("比武结束！");
          this.tip='比武结束!';
          this.examTime=0;
          this.canAnwser=false;
          clearInterval(this.examTimer);
          return false;
        }else if(nowTime<this.time_list.startTimeLL){
          console.log("理论比武还没开始！");
          this.tip='理论比武还没开始！';
          this.examTime=0;
          this.canAnwser=false;
          return false;
        }else if(nowTime<this.time_list.endTimeLL){
          console.log("理论比武中！");




          if(this.progress==3){
            this.canAnwser=false;
            console.log("理论比武中,答题完成！");
            this.tip='理论比武已完成，VR比武还未开始，请稍后再试!';
            this.examTime=0;
          }else{

            this.examTime = parseInt((this.time_list.endTimeLL - nowTime) / 1000);
            this.canAnwser=true;
            if(this.examTime<=0){
              this.submit(1);
            }

          }
        }else if(nowTime<this.time_list.startTimeVR){
          console.log("VR比武还没开始！");
          this.tip='VR比武还未开始，请稍后再试!';
          this.examTime=0;
          this.canAnwser=false;
          this.progress=3;
          return false;
        }else if(nowTime<this.time_list.endTimeVR){
          console.log("VR比武中！");
          this.examTime = parseInt((this.time_list.endTimeVR - nowTime) / 1000);
          console.log("")
          this.progress=3;
          this.canAnwser=true;
          // if(this.progress==this.lastType){
          //   this.examTime=0;
          //   this.canAnwser=false;
          //   clearInterval(this.examTimer);
          // }
        }else if(nowTime>this.time_list.endTimeVR){
          console.log("VR比武结束！");
          this.tip='VR比武结束!';
          this.examTime=0;
          this.canAnwser=false;
          this.progress=this.lastType;
          clearInterval(this.examTimer);
          return false;
        }
        // this.examTime -= 1;
        // if (this.examTime == 0) {
        //   clearInterval(timer);
        //   this.jumpRank();
        // }
        // console.log("this.vrTime..........",this.vrTime)
        // if(this.vrTime>0){
        //   this.vrTime -=1;
        //   if(this.progress!=3){
        //     this.progress=3
        //   }
        //   console.log("this.vrTime..........",this.vrTime)
        // }else{
        //
        //
        //   if(this.progress!=3){
        //     this.progress=3
        //     // console.log("this.vrTime.....this.progress.....",this.progress)
        //     // this.progress =
        //     //   resp.content.number == 0 ? this.tixing[0] - 1 : resp.content.number;
        //   }
        // }
      }, 1000);
    },
    changeExamType() {


      if (this.progress > 2) return;
      this.topicActive = [];
      this.aswerActive = [];
      this.answerInfo = this.dataList[this.examType].map((item) => {
        this.topicActive.push(false);
        this.aswerActive.push([]);
        return {
          id: item.id,
          is_true: item.timu.is_true,
          choose: [],
        };
      });
      if(this.$refs.mainList){
        this.$refs.mainList.scrollTop = 0
      }


      // this.$refs.mainList.scrollTop = 0;
      // document.getElementById("main_list").scrollTop = 0;
    },
    phInfoFun() {
      if (this.phTimer) {
        clearInterval(this.phTimer);
        this.phTimer = null;
      }
      let param = {
        shijuan_id: this.dataList.shijuan_id,
        action: this.phType,
      };
      // this.getphInfo(param);
      // this.phTimer = setInterval(() => {
      //   this.getphInfo(param);
      // }, 1000 * 60);
    },
    async start() {
      let param = {
        shijuan_id: this.dataList.shijuan_id,
        user_id: this.user_id,
      };
      let resp = await this.startExam(param);
      if (resp && resp.status.state == 1000) {
        this.progress =
          resp.content.number == 0 ? this.tixing[0] - 1 : resp.content.number;
        console.log("c....this.progress.....",this.progress)
        this.score_id = resp.content.score_id;


      }
      this.phInfoFun();
    },
    choose(index, pick) {
      // console.log(index,pick)
      if (this.examType == "duoxuan") {
        let choose = this.answerInfo[index].choose;
        let idx = choose.indexOf(pick);
        // console.log("idx:", idx);
        if (idx != -1) {
          choose.splice(idx, 1);
          // console.log("choose:", choose);
        } else {
          choose.push(pick);
        }
        this.answerInfo[index].choose = choose;
        this.topicActive[index] = this.answerInfo[index].choose.length
          ? true
          : false;
        this.$set(this.aswerActive, index, choose);
      } else {
        this.answerInfo[index].choose = [pick];
        // console.log(this.answerInfo[index].choose);
        this.topicActive[index] = true;
        this.$set(this.aswerActive, index, [pick]);
        // console.log(this.aswerActive[index].includes("B"));
      }
    },
    submit(type=0) {
      if (this.progress == 3) {

        this.$confirm('是否提交?', '', {
                  confirmButtonText: '提交',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {

                   this.vr_iframe = document.getElementById("vr_iframe");
                   this.vr_iframe.contentWindow.postMessage("vr_submit", "*");
                   //this.vr_iframe.contentWindow.vr_submit()
                   this.endVr();
                   this.jumpRank();
                   return;

                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });
                });


      }
      console.log("type=========",type,this.progress)
      if(type==0){
        if (this.topicActive.indexOf(false) > -1) {
          if(this.progress>=3) return false;//vr 不提示
          return this.$message.warning("请答完此部分题目后再提交");
        }
      }


      let infoArr = this.answerInfo.map((item) => {
        let choose = item.choose.sort();
        choose = choose.join("");
        return {
          id: item.id,
          is_true: item.is_true,
          choose,
          type: this.progress + 1,
        };
      });
      let info = JSON.stringify(infoArr);
      // console.log(info);
      // console.log(infoArr);
      let param = {
        score_id: this.score_id,
        info,
      };
      this.submitInfo(param).then((resp) => {
        if (resp && resp.status.state == 1000) {
          if (this.progress < this.tixing[this.tixing.length - 1]) {
            this.$message.success("提交成功，开始下一部份答题");
            this.progress = this.tixing[this.tixing.indexOf(this.progress) + 1];
            this.changeExamType();
          }
        } else {
          this.$message.error("提交失败");
        }
      });
    },
    endVr(){
      let param = {
        score_id: this.score_id
      }
      this.examEnd(param)
    },
    jumpRank() {
      console.log("jumpRank.................")
      // if (this.is_show == 1) {
      //   this.$router.replace(
      //     `/rank?user_id=${this.user_id}&user_name=${this.user_name}`
      //   );
      // } else {
      clearInterval(this.examTimer);
      this.progress=this.lastType;
        this.canAnwser=false;
        this.$message.warning("比武已完成");
      this.tip='';
      // location.reload();


      // this.logout();
        // location.reload();
        // setTimeout(() => {
        //   window.history.back();
        // }, 1000);
      // }
    },
    hideRight() {
      this.isShow = false;
    },
    showRight() {
      this.isShow = true;
    },
  },

  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);

    }
    if(this.examTimer){
      clearInterval(this.examTimer);
    }

  },
};
</script>
<style scoped lang="scss">
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/Question/index.vue